import axios from "axios";
import { countriesDetails, verifiedPaymentGateWayUrl } from "../../constants";
import { loadStripe } from "@stripe/stripe-js";

export const createStripeAccount = async (
  userAddress,
  chainId,
  countryCode,
) => {
  return await axios({
    method: "POST",
    url: verifiedPaymentGateWayUrl,
    data: {
      action: "create_account",
      user_address: userAddress,
      country: countryCode,
      chain_id: chainId,
    },
  })
    .then((res) => {
      if (res?.data?.accountId) {
        return res?.data?.accountId;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.log("create stripe account failed with error: ", err?.message);
      return null;
    });
};

export const createStripeOnBoardLink = async (
  accountId,
  countryCode,
  chainId,
) => {
  const countryToUse = countriesDetails?.find(
    (cnt) =>
      cnt?.code?.toLocaleLowerCase() === countryCode?.toLocaleLowerCase(),
  );
  if (countryToUse) {
    const redirectUri =
      window.location.origin +
      `/#action=set-user-custody-bank&country=${countryCode}-${countryToUse.currency}&account_id=${accountId}&bank_type=stripe`;
    return await axios({
      method: "GET",
      url: verifiedPaymentGateWayUrl,
      params: {
        action: "create_link",
        accountid: accountId,
        country: countryCode,
        return_url: redirectUri,
        refresh_url: window.location.origin + "/",
        chainId,
      },
    })
      .then((res) => {
        if (res?.data?.url) {
          return res?.data?.url;
        } else {
          return null;
        }
      })
      .catch((err) => {
        console.log(
          "create stripe on board link failed with error: ",
          err.message,
        );
        return null;
      });
  } else {
    return null;
  }
};

export const getStripeAccountStatus = async (
  accountId,
  countryCode,
  chainId,
) => {
  return await axios({
    method: "GET",
    url: verifiedPaymentGateWayUrl,
    params: {
      action: "get_account_status",
      account_id: accountId,
      country: countryCode,
      chainId,
    },
  })
    .then((res) => {
      if (res?.data?.account?.kyc_accepted) {
        return res?.data?.account?.kyc_accepted;
      } else {
        return null;
      }
    })
    .catch((err) => {
      console.log("get stripe account status failed with error: ", err.message);
      return null;
    });
};

export const createVerifiedCashIssueRequest = async (
  chainId,
  userAddress,
  amount,
  country,
  custodianAccountId,
  currency,
  issueCurrency,
) => {
  return await axios({
    method: "POST",
    url: verifiedPaymentGateWayUrl,
    data: {
      action: "create_cash_issue_request",
      amount: amount,
      investor_address: userAddress,
      country: country,
      custodianAccountId: custodianAccountId,
      pay_currency: currency,
      issue_currency: issueCurrency,
      chainId,
    },
  })
    .then((res) => {
      if (res?.data) {
        if (res?.data?.error) {
          return null;
        } else {
          return res?.data;
        }
      } else {
        return null;
      }
    })
    .catch((err) => {
      // console.log("err: ", err);
      console.error(
        "stripe create cash request failed with error: ",
        err?.message,
      );
      return null;
    });
};

export const fetchReceiptFromIntent = async (clientSecret) => {
  const stripePromise = await loadStripe(process.env.REACT_APP_STRIPE_API_KEY);
  const elements = stripePromise.elements();
  const cardElement = elements.create("card");
  const { error, paymentIntent } = stripePromise.confirmCardPayment(
    clientSecret,
    {
      payment_method: {
        card: cardElement,
      },
    },
  );

  if (error) {
    return null;
  } else if (paymentIntent?.status === "succeeded") {
    const receiptUrl = paymentIntent?.charges?.data[0]?.receipt_url;
    return receiptUrl;
  } else {
    return null;
  }
};
